export * from './conformite-texte';
